import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { IpvService } from 'src/app/services/ipv.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-ipv',
  templateUrl: './create-ipv.component.html',
  styleUrls: ['styles.css']
})
export class CreateIpvComponent implements OnInit {


  public typeArray=[];

  public ipvForm = this.fb.group({
    title: ['', Validators.required],
    opcA: this.fb.group({
      text:[''],
      value:[0]
    }) ,
    opcB: this.fb.group({
      text:[''],
      value:[0]
    }) ,
    opcC: this.fb.group({
      text:[''],
      value:[0]
    }) ,
    types: [''],
  });


  constructor(private fb:FormBuilder, private ipvService:IpvService) { 
    this.clearAll();
  }

  ngOnInit(): void {
  }

  reset(){
    this.ipvForm.reset();
  }

  clearAll(){
    this.typeArray[0]=false;
    this.typeArray[1]=false;
    this.typeArray[2]=false;
    this.typeArray[3]=false;
    this.typeArray[4]=false;
    this.typeArray[5]=false;
    this.typeArray[6]=false;
    this.typeArray[7]=false;
    this.typeArray[8]=false;
    this.typeArray[9]=false;
    this.typeArray[10]=false;
    this.typeArray[11]=false;
    this.ipvForm.reset();

  }

  register(){                       /////// Si no se ingresa puntaje en una de las posibles respuestas se almacena NULL
    let auxArr=[];
    if(this.typeArray[0]==true) auxArr.push('DGV');
    if(this.typeArray[1]==true) auxArr.push('I');
    if(this.typeArray[2]==true) auxArr.push('II');
    if(this.typeArray[3]==true) auxArr.push('III');
    if(this.typeArray[4]==true) auxArr.push('IV');
    if(this.typeArray[5]==true) auxArr.push('V');
    if(this.typeArray[6]==true) auxArr.push('VI');
    if(this.typeArray[7]==true) auxArr.push('VII');
    if(this.typeArray[8]==true) auxArr.push('VIII');
    if(this.typeArray[9]==true) auxArr.push('IX');
    this.ipvForm.get('types').setValue(auxArr);
    //console.log(this.ipvForm.value);
    this.ipvService.createQuestion(this.ipvForm.value).subscribe(
      resp=> {
        let timerInterval
        Swal.fire({
          title: 'Pregunta creada',
          html: '',
          timer: 1000,
          timerProgressBar: true,
          willOpen: () => {
            Swal.showLoading()
          },
          onClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            
          }
        })
        this.clearAll();
      },
      err=>{
        this.clearAll();
        console.log(err)
      }
    )

  }

}
